import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'allowZero'
})
export class AllowZeroPipe implements PipeTransform {

  transform(value?: string | number, ...args: unknown[]): unknown {
    if (value == null ) {
      return '-';
    }
    
    return +value || 0;
  }

}
